import { Compass, Gamepad2, ExternalLink, ChevronRight } from "lucide-react";
import { Reveal, SectionHeading } from "./shared";
import { useLanguage } from "@/i18n/LanguageContext";

export default function PartnerFlow() {
  const { t } = useLanguage();
  const STEPS = [
    { key: "f1", Icon: Compass },
    { key: "f2", Icon: Gamepad2 },
    { key: "f3", Icon: ExternalLink },
  ];
  return (
    <section data-testid="partner-flow-section" className="px-6 py-4">
      <SectionHeading index="03" eyebrow="How It Works" title={t("flowHeading")} testId="partner-flow-heading" />
      <Reveal>
        <div className="rounded-2xl border border-[rgba(22,99,230,0.14)] bg-white p-4 shadow-[0_10px_30px_-16px_rgba(11,61,145,0.3)]">
          <div className="relative flex items-stretch justify-between gap-1" data-testid="partner-flow-steps">
            <div aria-hidden="true" className="absolute left-[16%] right-[16%] top-[20px] h-px bg-[linear-gradient(90deg,rgba(22,99,230,0.15),rgba(242,183,5,0.5),rgba(22,99,230,0.15))]" />
            {STEPS.map((s, i) => (
              <div key={s.key} className="relative flex flex-1 items-center gap-1">
                <div className="flex flex-1 flex-col items-center text-center" data-testid={`partner-flow-step-${i + 1}`}>
                  <span
                    className={`flex h-10 w-10 items-center justify-center rounded-full ring-4 ring-white ${
                      i === 2
                        ? "bg-[rgba(242,183,5,0.18)] text-[#B8860B] shadow-[0_6px_16px_-6px_rgba(242,183,5,0.5)]"
                        : "bg-[rgba(22,99,230,0.1)] text-[#1663E6] shadow-[0_6px_16px_-6px_rgba(22,99,230,0.4)]"
                    }`}
                  >
                    <s.Icon className="h-[18px] w-[18px]" strokeWidth={2} />
                  </span>
                  <p className="mt-2 text-[11px] font-medium leading-snug text-[#0F1E3D]">{t(s.key)}</p>
                </div>
                {i < STEPS.length - 1 && (
                  <ChevronRight className="h-4 w-4 shrink-0 text-[#1663E6]/50" strokeWidth={2.5} aria-hidden="true" />
                )}
              </div>
            ))}
          </div>
          <p className="mt-4 border-t border-[rgba(22,99,230,0.1)] pt-3 text-[11px] leading-relaxed text-slate-500" data-testid="partner-flow-note">
            {t("flowNote")}
          </p>
        </div>
      </Reveal>
    </section>
  );
}
